<template>
  <div>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin:20px 0"
      ref="table"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="toPage(row, index)"
        ></Button>
      </template>
    </Table>
    <div
      style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <Page :total="total" @on-change="pageChange" />
      <Button type="primary" style="margin-top:15px" @click="goBack"
        >返回</Button
      >
    </div>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
export default {
  props: ["userInfo"],
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      columns: [
        {
          title: "查看",
          slot: "action",
          align: "center",
          minWidth: 70
        },
        {
          title: "员工姓名",
          key: "userName",
          align: "center",
          minWidth: 120
        },
        {
          title: "员工号",
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: "部门",
          key: "department",
          align: "center",
          minWidth: 120
        },
        {
          title: "职位",
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: "业务单元",
          key: "businessUnit",
          align: "center",
          minWidth: 120
        },
        {
          title: "年度",
          key: "year",
          align: "center",
          minWidth: 100
        },
        {
          title: "直接主管",
          key: "dirSupUserName",
          align: "center",
          minWidth: 120
        }
      ],
      data: [{}]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    goBack() {
      this.$emit("back");
    },
    getData() {
      let obj = {
        levemNum: 1,
        ...{
          empCode: this.$props.userInfo.empCode,
          year: this.$props.userInfo.year
        },
        ...this.pageInfo
      };
      this.loading = true;
      axios
        .post("/achUpdatePlan/selectAchUpdatePlanReportInfo", obj)
        .then(res => {
          if (res) {
            this.data = res.achUpdateInfoList;
            this.total = parseInt(res.pageInfo.total);
            this.item = res;
            this.isManager = res.isManager;
          }
          this.loading = false;
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    toPage(row, index) {
      this.$router.push({
        path: "/F4861F9E4EB7B7DE62E634E5A81A4043/A3FFBEBFDB713E27",
        query: { isDirSup: row.isDirSup, id: row.id }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/index/components/PerformanceImprovement.vue